module.exports = __webpack_public_path__ + "img/cautionwhite.ee83020c.svg";